import { render, staticRenderFns } from "./BasePicture.global.vue?vue&type=template&id=244abae2&functional=true&"
import script from "./BasePicture.global.vue?vue&type=script&lang=js&"
export * from "./BasePicture.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports